"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;
exports.update = update;

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _immutable = require("immutable");

var _uniqueId = _interopRequireDefault(require("transmute/uniqueId"));

var URI = 'engagements/v1/activity-types';

function fetch() {
  return (0, _ImmutableAPI.get)(URI).then(function (results) {
    return results.map(function (activityType) {
      return activityType.set('id', (0, _uniqueId.default)('activityType-'));
    });
  });
}

function update(expectedCurrentNameOrder, newNameOrder) {
  return (0, _ImmutableAPI.put)(URI, (0, _immutable.Map)({
    expectedCurrentNameOrder: expectedCurrentNameOrder,
    newNameOrder: newNameOrder
  }));
}